import { render } from "./LgerListAccount.vue?vue&type=template&id=5e0557b0&ts=true"
import script from "./LgerListAccount.vue?vue&type=script&lang=ts"
export * from "./LgerListAccount.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__